/**
 * La conferma prima di pubblicare una versione del listino: dice cosa cambia DAVVERO (quanti prodotti prendono il prezzo
 * nuovo, quanti escono dal listino, se partono avvisi), non una parafrasi. I preventivi non cambiano: lo dice anche qui.
 */
import React from 'react';
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { BozzaDelListino } from '../../services/listiniFornitoriService';

interface Props {
  fornitore: string;
  bozza: BozzaDelListino;
  avvisa: boolean;
  lavorando: boolean;
  onAnnulla: () => void;
  onConferma: () => void;
}

export const ConfermaPubblicazione: React.FC<Props> = ({ fornitore, bozza, avvisa, lavorando, onAnnulla, onConferma }) => {
  const { t } = useTranslation('listini');
  return (
    <Dialog open onClose={() => !lavorando && onAnnulla()} fullWidth maxWidth="xs">
      <DialogTitle>{t('pubblica.conferma_titolo', { numero: bozza.numero })}</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          <Typography variant="body2" fontWeight={600}>{fornitore}</Typography>
          <Typography variant="body2">{t('pubblica.conferma_prezzi', { count: bozza.prezzi_da_scrivere })}</Typography>
          {bozza.spariti > 0 && <Typography variant="body2">{t('pubblica.conferma_escono', { count: bozza.spariti })}</Typography>}
          <Typography variant="body2">{t('pubblica.conferma_preventivi')}</Typography>
          <Alert severity={avvisa ? 'warning' : 'info'} variant="outlined">{t(avvisa ? 'pubblica.conferma_avvisi_si' : 'pubblica.conferma_avvisi_no')}</Alert>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onAnnulla} disabled={lavorando} sx={{ minHeight: 40 }}>{t('pubblica.annulla')}</Button>
        <Button variant="contained" onClick={onConferma} disabled={lavorando} sx={{ minHeight: 40 }} startIcon={lavorando ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : undefined}>
          {lavorando ? t('pubblica.in_corso') : t('pubblica.bottone', { numero: bozza.numero })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
